import { defineRoute, NotFound } from '@colescba/ui'

import Home from '@/views/Home'

export default [
  defineRoute(
    {
      path: '/',
      name: 'Home',
      component: Home,
      props: true,
    },
    { text: 'Inicio' },
    {
      svg: 'OutlineHomeIcon',
      classes: 'w-7 h-7 text-colescba-blue-700 group-hover:text-colescba-blue-800',
    },
    true, // isNavigationLink,
    true, // isHamburgerLink,
  ),

  // siempre al final esta ruta
  defineRoute(
    {
      path: '*',
      name: 'NotFound',
      props: true,
      component: NotFound,
    },
    { text: '' },
    null, // icono
    false, // isNavigationLink,
    false, // isHamburgerLink,
  ),
]
